/**
 * 플랫폼 도메인 상수.
 */

/**
 * 플랫폼 단일 라이선스 (GDEV-235).
 *
 * 5/11 본 회의 결정: License = 단일 라이선스만 사용 (다중 라이선스 폐기).
 * interim 값 = `apache-2.0` (CLI/seed 기존 de-facto default 와 정합).
 * ETRI 표준 라이선스 텍스트 수령 시 (안건 #7-1, 5월 내 송부 대기) 이 값 1곳만 교체.
 * backend 대응 상수: `app.config.Settings.platform_license`.
 */
// 서버 응답 전 기본값일 뿐이다. 화면은 `usePlatformLicense()` 로 /config 의 실제 값을
// 쓴다 — 이 상수가 apache-2.0 으로 남아 실제 설정(cc-by-nc-4.0)과 달랐다 (2026-10-13).
export const PLATFORM_LICENSE = 'cc-by-nc-4.0'

/**
 * 커뮤니티 외부 링크 대상 — HF 조직 페이지 (GDEV-222).
 *
 * 2026-05-01 ETRI 회신: 커뮤니티 연동 = "링크만 표시" (자체 커뮤니티 UI 없음).
 * 조직 slug 는 backend `HF_ORGANIZATION` 과 동일하게 유지한다.
 */
export const HF_COMMUNITY_URL = 'https://huggingface.co/etri-humanoidrobotsystems'

/**
 * 표준 카테고리 taxonomy — Datasets / Curations / Models 필터·등록에서 공용.
 *
 * backend `app.services.categorization` 의 ROBOT_CATEGORIES / TASK_CATEGORIES 와
 * 정합(분류기 기준). 세 페이지가 동일 고정 목록을 쓰도록 단일 출처로 둔다.
 * 필터는 robot_category / task_category(데이터셋·큐레이션) 또는 robot_type / task
 * (모델, 동일 값) 로 매칭한다.
 */
export const ROBOT_CATEGORIES = ['humanoid', 'quadruped', 'mobile', 'arm', 'hand', 'drone'] as const

export const TASK_CATEGORIES = [
  'manipulation',
  'locomotion',
  'navigation',
  'grasping',
  'imitation',
] as const

/** "미분류" 필터 sentinel — backend `UNCATEGORIZED` 와 동일. category NULL 매칭. */
export const UNCATEGORIZED = 'uncategorized'

/**
 * 공식 운영 문의처 — 단일 출처 (QA M-10).
 *
 * Contact 페이지는 `kaihumanoid@gmail.com`, 오류 페이지는
 * `support@etri.re.kr` 로 서로 달랐다. **발주처가 지정한 주소는 전자**이므로
 * 그쪽으로 통일한다.
 *
 * 개인 계정 형식이지만 발주처 요청 사항이다. 임의로 바꾸지 말 것.
 * 변경이 필요하면 여기 한 곳만 교체한다.
 */
export const SUPPORT_EMAIL = 'kaihumanoid@gmail.com'

/**
 * 데이터 원문 그대로 보여주면 안 되는 값의 사용자 문구 (QA M-2).
 *
 * LeRobot `info.json` 의 `robot_type` 이 `"unknown"` 인 데이터셋이 있는데,
 * 카드에 그대로 노출돼 있었다.
 */
export function displayMetaValue(value: string | null | undefined): string | null {
  if (!value) return null
  return value.trim().toLowerCase() === 'unknown' ? '미분류' : value
}
